// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_f3GBK","secondaryColumnCell":"secondary-column-cell_f3GBK","name":"name_YcMHl"};